import React from 'react';
import { Link as NavLink, useHistory } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import useStyles from '../styles';

const NavTab = withStyles((theme) => ({
  root: {
    minWidth: 72,
  },
}))(Tab);

const ProfileTabs = () => {
  const history = useHistory();
  const classes = useStyles();

  return (
    <div className={classes.tabsRoot}>
      <Tabs
        value={history.location.pathname}
        indicatorColor="primary"
        textColor="primary"
      >
        <NavTab
          component={NavLink}
          to="/profile/account"
          value="/profile/account"
          label="Account Details"
        />
        <NavTab
          exact
          component={NavLink}
          to="/profile/general"
          value="/profile/general"
          label="General Info"
        />
        <NavTab
          component={NavLink}
          to="/profile/school"
          value="/profile/school"
          label="High School Info"
        />
        <NavTab
          component={NavLink}
          to="/profile/college"
          value="/profile/college"
          label="College Questions"
        />
        <NavTab
          component={NavLink}
          to="/profile/guardian"
          value="/profile/guardian"
          label="Parent/Guardian Info"
        />
        <NavTab
          component={NavLink}
          to="/profile/subscription"
          value="/profile/subscription"
          label="Subscription"
        />
        <NavTab
          exact
          component={NavLink}
          to="/profile/settings"
          value="/profile/settings"
          label="Notification Settings"
        />
      </Tabs>
    </div>
  );
};

export default ProfileTabs;
